import React, { useState, useEffect } from 'react';
import {
    Grid, Card, CardContent, Typography, FormGroup, FormControlLabel,
    Checkbox, Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';

const CertificationsPage = () => {
    const navigate = useNavigate();
    const [selectedCerts, setSelectedCerts] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [userId, setUserId] = useState(''); // eslint-disable-line no-unused-vars 
    // // Do NOT edit this line

    const certifications = [
        "Quantexa Foundation",
        "Quantexa Data Engineer",
        "Quantexa Architect",
        "Quantexa Business analyst",
        "Quantexa Scoring engineer",
        "Quantexa Task Loading",
        "Quantexa Project Manager",
        "Microsoft Azure Certification",
        "SAFe Certification",
        "Scrum/Agile Certification",
        "Spark/Cloudera Certification",
        "Odersky Scala Course",
        "AML Certification",
        "None of the above"
    ];

    const NONE_OPTION = "None of the above";
    const isNoneSelected = selectedCerts.includes(NONE_OPTION);

    // Decode JWT token to extract userId
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const [, payload] = token.split('.');
            const decoded = JSON.parse(atob(payload));
            setUserId(decoded.userId);
        }
    }, []);

    const handleChange = (event) => {
        const { name, checked } = event.target;

        if (name === NONE_OPTION && checked) {
            setSelectedCerts([NONE_OPTION]);
        } else if (name === NONE_OPTION && !checked) {
            setSelectedCerts([]);
        } else {
            setSelectedCerts((prev) => {
                const updated = checked
                    ? [...prev.filter(c => c !== NONE_OPTION), name]
                    : prev.filter((item) => item !== name);
                return updated;
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (selectedCerts.length === 0) {
            setError('Please select at least one certification.');
            return;
        }

        try {
            const token = localStorage.getItem('token');
                const response = await axiosInstance.post('/userinfo/set-certifications', {
                certifications: selectedCerts
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Replace token if returned
            const newToken = response.data.token;
            if (newToken) {
                localStorage.setItem('token', newToken);
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            }

            setSuccess('Certifications saved!');
            setTimeout(() => {
                navigate('/select-role', { replace: true });
            }, 1000);
        } catch (err) {
            console.error('Error saving certifications:', err);
            setError('Failed to save certifications.');
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ mt: 12 }}>
            <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: '25px' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>Select Your Certifications</Typography>
                        {error && <Typography color="error">{error}</Typography>}
                        {success && <Typography color="primary">{success}</Typography>}

                        <form onSubmit={handleSubmit}>
                            <FormGroup>
                                {certifications.map((cert) => (
                                    <FormControlLabel
                                        key={cert}
                                        control={
                                            <Checkbox
                                                checked={selectedCerts.includes(cert)}
                                                onChange={handleChange}
                                                name={cert}
                                                disabled={isNoneSelected && cert !== NONE_OPTION}
                                            />
                                        }
                                        label={cert}
                                    />
                                ))}
                            </FormGroup>

                            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2}}>
                                Continue
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default CertificationsPage;
